<template>
  <div class="dh-psy-extract container article-feature">
    <div v-if="text && nrkStyle" class="quote widget rich">
      <blockquote class="cf">
        <div class="quote-text">
          <i></i>
          <p>{{ text }}</p>
        </div>
        <small v-if="author" class="quote-source">
          <i></i>
          {{ author }}
        </small>
      </blockquote>
    </div>
    <div v-else class="dh-psy-quote">
      <blockquote>
        <div>
          <p>
            <span aria-hidden class="dh-psy-quote__mark dh-psy-quote__mark--left">&laquo;</span>
            <span class="dh-psy-quote__text">{{ text }}</span>
            <span aria-hidden class="dh-psy-quote__mark  dh-psy-quote__mark--right">&raquo;</span>
          </p>
        </div>
        <small v-if="author">
          {{ author }}
        </small>
      </blockquote>
    </div>
  </div>
</template>

<style lang="postcss">
  .dh-psy-extract.article-feature {
    padding: 0 18px;

    & > * {
      float: none;
      width: auto;
    }

    & i {
      filter: hue-rotate(313deg) brightness(160%);
    }
  }

  .dh-psy-extract__wrapper {
    float: none;
    margin: 50px 0;
    padding: 20px;
    box-sizing: border-box;
    width: calc(100vw - 200px);
    max-width: calc(100% + 100px);
    font-size: 24px;
    font-weight: 100;
    font-family: menlo, inconsolata, consolas, 'fira mono', 'noto mono', 'droid sans mono',
      'dejavu sans mono', 'liberation mono', 'ubuntu mono', monaco, 'courier new', monospace;
  }

  .dh-psy-quote {
    width: 480px;
    margin: 50px auto;
    max-width: calc(100% - 4em);
    display: flex;
    justify-content: center;
    align-content: center;

    & blockquote {
      margin: 0;
    }

    & p {
      position: relative;
      width: 100%;
      font-family: NRK Etica Slab;
      margin: 0;
      line-height: 1.5;
      font-size: calc(1.1em + 0.1vw);

      @media (min-width: 450px) {
        font-size: calc(1.2em + 0.1vw);
      }

      @media (min-width: 650px) {
        font-size: calc(1.3em + 0.1vw);
      }
      @media (min-width: 800px) {
        font-size: calc(1.4em - 0.1vw);
      }
    }

    & .dh-psy-quote__text {
    }

    & small {
      display: inline-block;
      font-weight: 400;
      font-size: 0.9em;
      max-width: 60%;
      margin: 20px auto auto 2em;
      box-shadow: 0px 4px white inset, 0px -6px white inset, 2px 39px #8debd6 inset;
    }
  }

  .dh-psy-quote__mark {
    width: 22px;
    display: inline;
    position: absolute;

    &.dh-psy-quote__mark--right {
      bottom: 0;
      padding-left: 2px;
    }

    &.dh-psy-quote__mark--left {
      left: -22px;
      text-align: right;
    }
  }
</style>

<script>
export default {
  props: ['content', 'id', 'author', 'text', 'nrkStyle'],
  computed: {
    src() {
      return `/serum/render?id=${this.id}`
    }
  }
}
</script>
